/**
 * @file Mapping between key name and key codes
 * @author Heino Lenting
 */
export var keyCodes = {
    'up': 38,
    'right': 39,
    'down': 40,
    'left': 37,
    'enter': 13
};
